import { computable, observable } from "@chorda/core";
import { ColumnLayout, RowLayout } from "chorda-bulma";
import { Dropdown, Paragraph, Text, DropdownItem } from "../../helpers";
import { COUNTRIES } from "../../data";
import { withMultiselect } from "./common/with-multiselect";
import { withBlueprint } from "../../utils";
const countries = observable(COUNTRIES.slice(0, 50), (v) => v.alpha2Code);
const value1 = observable(['BE']);
const CountryMultiDropdown = (props) => withMultiselect(Dropdown(props)); //Dropdown
export default () => {
    return ColumnLayout([
        RowLayout([
            Text({
                as: Paragraph,
                text$: () => computable(() => value1.join(','))
            }),
            withBlueprint({
                css: 'mb-140px',
                as: CountryMultiDropdown({
                    value$: () => value1,
                    items$: () => computable(() => countries.map(c => { return Object.assign(Object.assign({}, c), { id: c.alpha2Code }); })),
                    itemAs: DropdownItem({
                        isSelected$: ({ selected, item }) => computable(() => {
                            return selected.filter(s => s.id == item.id).length > 0;
                        }),
                    }),
                }),
            })
        ])
    ]);
};
